import React from "react";
import AddOnManager from "./AddOnManager";
import { useDispatch } from "react-redux";
import { getShopAddOns } from "../../actions/shop";
import { useEffect } from "react";

export default function AddOns() {

	const dispatch = useDispatch();

	useEffect(() => {
		dispatch(getShopAddOns());
	}, [dispatch]);

	return <div className="addOns">
		<section>
			<h4>Product Add-ons</h4>
			<div className="inner">
				Add-ons are a powerful way to extend products. Before you add them to your products, you'll need to create a few.
			<br /><br />
			The best add-ons are quite generic so they can be re-used on different products. For example <b>small</b>, <b>medium</b> and <b>large</b> are good add-ons for clothing sizes.
			</div>
		</section>
		<section>
			<AddOnManager />
		</section>
	</div>
}